import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=69d27ec8&scoped=true&"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js&"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js&"
import style0 from "./terms-and-conditions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./terms-and-conditions.vue?vue&type=style&index=1&id=69d27ec8&lang=scss&scoped=true&"
import style2 from "./terms-and-conditions.vue?vue&type=style&index=2&id=69d27ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d27ec8",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QOptionGroup,QTabs,QTab,QTabPanels,QTabPanel,QBtn,QSpinnerIos} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QOptionGroup,QTabs,QTab,QTabPanels,QTabPanel,QBtn,QSpinnerIos})
